import { HttpRequest } from "../../api/core/request/HttpRequest";
import { RequestConstants } from "../../api/core/request/RequestConstants";
import { SpineManager } from "../../game/manager/SpineManager";
import { EventHandler } from "../../util/event/EventHandler";
import { FileExtension } from "../file/FileType";
import { AtlasAssetLoader } from "./AtlasAssetLoader";
/*
 * AtlasRequest.ts
 */
export class AtlasRequest {
    constructor(url) {
        this.url = url;
    }
    onComplete(handler, scope) {
        this.completeHandler = new EventHandler(handler, scope);
    }
    load() {
        this.request = new HttpRequest(RequestConstants.GET, this.url);
        this.request.setContentType(RequestConstants.APPLICATION_XML);
        this.request.setResponseType(RequestConstants.TEXT);
        this.request.onComplete(this.handleComplete, this);
        this.request.onError(this.handleError, this);
        this.request.send();
    }
    handleComplete() {
        const response = this.request.getResponse();
        const assetLoader = new AtlasAssetLoader(this.url, response, (records) => {
            SpineManager.getInstance().preload(this.url, response);
            this.completeHandler.call(this);
        });
    }
    handleError() {
        this.completeHandler.call(this);
    }
    getResponseText() {
        return this.request.getRequest().responseText;
    }
    findAtlasImgUrls(atlasData, atlasUrl) {
        //Break the atlas into lines, then find the lines containing an image filename;
        const lines = atlasData.match(/^.*$/mg);
        const imageNames = lines.filter(line => line.toLowerCase().indexOf(FileExtension.PNG) > -1 || line.toLowerCase().indexOf(FileExtension.WEBP) > -1);
        const atlasPath = atlasUrl.substring(0, atlasUrl.lastIndexOf("/") + 1);
        return imageNames.map(imageName => atlasPath + imageName);
    }
    waitForImages(imageUrls) {
        let proms = [];
        imageUrls.forEach(imageUrl => {
            proms.push(new Promise(resolve => {
                const atlasImg = new Image();
                atlasImg.onload = () => {
                    resolve();
                };
                atlasImg.src = imageUrl;
            }));
        });
        return Promise.all(proms);
    }
}
//# sourceMappingURL=AtlasRequest.js.map